module.exports = __webpack_public_path__ + "img/family_planning.e7bde445.png";